<template>
    <div>
        <div 
            class="mobile-popup-overlay" 
            :class="{'active': active}"
            @click="$emit('close')"
        >
        </div>
        <div class="mobile-popup" :class="{'active': active}">
            <div 
                class="mobile-popup__close bg-primary"
                @click="$emit('close')"
            >
                <font-awesome-icon
                    class="text-light" 
                    :icon="['fas', 'chevron-down']"
                />
            </div>
            <div class="mobile-popup__body">
                <div class="mobile-popup__body__review-booking">
                    <b-container fluid>
                        <div
                            class="mobile-popup__body__review-booking__content"
                        >
                            <div class="mobile-popup__body__review-booking__content__block">
                                <div class="mobile-popup__body__review-booking__content__block__body">
                                    <online-booking-checkout-review-booking />
                                    <div
                                        class="mobile-popup__body__review-booking__content__separator"
                                        v-if="isCancellationPolicySet"
                                    ></div>
                                    <online-booking-checkout-review-cancellation-policies
                                        v-if="isCancellationPolicySet"
                                    />
                                </div> 
                            </div>
                            <div class="mobile-popup__body__review-booking__content__separator"></div>
                            <div class="mobile-popup__body__review-booking__content__block">
                                <div class="mobile-popup__body__review-booking__content__block__body">
                                    <online-booking-checkout-complete-booking 
                                        :invalid="invalid"
                                        :fields="fields"
                                        :button-variant="'primary'"
                                    />
                                </div> 
                            </div>
                        </div>
                    </b-container>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import { mapGetters } from 'vuex';
import OnlineBookingCheckoutReviewBooking from "../common/online-booking-checkout-review-booking.vue";
import OnlineBookingCheckoutCompleteBooking from "../common/online-booking-checkout-complete-booking.vue";
import OnlineBookingCheckoutReviewCancellationPolicies from '../common/online-booking-checkout-review-cancellation-policies.vue';

export default {
    components: {
        OnlineBookingCheckoutReviewBooking,
        OnlineBookingCheckoutCompleteBooking,
        OnlineBookingCheckoutReviewCancellationPolicies,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        fields: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters('onlineBooking', ['reservation']),
        isCancellationPolicySet() {
            return (
                this.reservation.cancellation_policy.cancellation_fee > 0 ||
                this.reservation.cancellation_policy.is_refunds_set
            );
        },
    },
}
</script>

<style lang="scss" scoped>
    .mobile-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 101;
        visibility: hidden;
        opacity: 0;
        transition: 0.3s cubic-bezier(.42,0,1,1);
        cursor: pointer;
        &.active {
            visibility: visible;
            opacity: 1;
            background-color: rgba(0, 0, 0, 0.8);
        }
    }
    .mobile-popup {
        --chevron-down-width: 36px;
        --chevron-down-height: 36px;
        position: fixed;
        top: calc(100% + var(--chevron-down-height) / 2);
        left: 0;
        bottom: 0;
        right: 0;
        transition: 0.3s cubic-bezier(.42,0,1,1);
        background-color: #fff;
        display: flex;
        flex-direction: column;
        z-index: 101;
        box-shadow: 0px -5px 20px rgba(0, 0, 0, 0.5);
        &.active {
            top: 15%;
        }
        &__close {
            position: absolute;
            z-index: 2;
            border-radius: 50%;
            width: var(--chevron-down-width);
            height: var(--chevron-down-height);
            left: calc(50% - var(--chevron-down-width) / 2);
            top: calc(0px - var(--chevron-down-height) / 2);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
        &__body {
            display: flex;
            flex-direction: column;
            flex: 1 1 auto;
            overflow: hidden;
            &__review-booking {
                overflow: auto;
                padding: 20px 0;
                &__content {
                    display: flex;
                    flex-direction: column;
                    &__block {
                        &__body {
                            margin-top: 24px;
                        }
                    }
                    &__separator {
                        border-bottom: 1px solid #dddddd;
                        margin: 24px 0;
                    }
                }
            }
        }
    }
</style>
